<template>
  <div class="n-invite-reg-code-box">
    
    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr0"
        v-model:value="vc_values[0]"
        :controls="false"
        :maxlength="1"
        @input="vcInput0"
        @keydown="vcKeydown0"/>

    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr1"
        v-model:value="vc_values[1]"
        :controls="false"
        :maxlength="1"
        @input="vcInput1"
        @keydown="vcKeydown1"/>

    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr2"
        v-model:value="vc_values[2]"
        :controls="false"
        :maxlength="1"
        @input="vcInput2"
        @keydown="vcKeydown2"/>

    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr3"
        v-model:value="vc_values[3]"
        :controls="false"
        :maxlength="1"
        @input="vcInput3"
        @keydown="vcKeydown3"/>

    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr4"
        v-model:value="vc_values[4]"
        :controls="false"
        :maxlength="1"
        @input="vcInput4"
        @keydown="vcKeydown4"/>

    <AInputNumber
        class="n-invite-reg-code-input"
        ref="inputArr5"
        v-model:value="vc_values[5]"
        :controls="false"
        :maxlength="1"
        @input="vcInput5"
        @keydown="vcKeydown5"
        />
    
  </div>
</template>

<script setup>
import {ref, watch, nextTick} from 'vue'
import {isNumber} from "lodash-es";
import { InputNumber as AInputNumber } from 'ant-design-vue/es';

const vc_values = ref([]);

const inputArr0 = ref();
const inputArr1 = ref();
const inputArr2 = ref();
const inputArr3 = ref();
const inputArr4 = ref();
const inputArr5 = ref();

const inputArr = [inputArr0, inputArr1, inputArr2, inputArr3, inputArr4, inputArr5];

const props = defineProps({
  vv: Boolean,
  resendTime: Number,
});
const emit = defineEmits(['afterFinished']);

watch(
    () => props.vv,
    to =>  {
      if (props.vv) {
        clear();
      }

    },
    { immediate: true },
);

watch(
    () => props.resendTime,
    to =>  {
      if (props.resendTime) {
        clear();
      }

    },
    { immediate: true },
);

function vcInput0(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect( 0);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 0);
  }
}

function vcInput1(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect( 1);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 1);
  }
}
function vcInput2(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect(2);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 2);
  }
}
function vcInput3(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect(3);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 3);
  }
}
function vcInput4(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect( 4);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 4);
  }
}
function vcInput5(inputValue){
  // 'Backspace'
  if(inputValue == null) {
    vcEffect(5);
  }else {// enter a number
    allowOnlyNumbers(inputValue, 5);
  }
}

function vcKeydown0(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect(0);
  }
}
function vcKeydown1(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect(1);
  }
  
}
function vcKeydown2(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect(2);
  }
  
}
function vcKeydown3(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect(3);
  } 
  
}
function vcKeydown4(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect(4);
  } 
  
}
function vcKeydown5(event){
  const k = event.key;
  if(k === 'Backspace') {
    vcEffect( 5);
  } 
}

function vcEffect(index){
  const prev = vc_values.value[index];
  if(prev != null && prev !== ''){
      // nop
    }else if(index-1 >= 0){
      const t = inputArr[index];        t.value.blur();
      const t_pre = inputArr[index-1];  t_pre.value.focus();
      
      
    }
}

function allowOnlyNumbers(value, index){
  const index2 = index + 1;
  
  if( value !== '') {
    // setTimeout(() => {
      let all = true;
      for (let i = 0; i < inputArr.length; i++) {
        const v = vc_values.value[i];

        if(!isNumber(v)) {
          all = false;
          break;
        }
      }

      if(index <5 && (!all)){
        const t = inputArr[index];
        const t_next = inputArr[index2];
        t.value.blur();
        t_next.value.focus();
      }

      if(all){
        // call send sms verify code
        const vcode = vc_values.value.join('');
        blurAll();
        emit('afterFinished', vcode);
      }else {
        //NOP
      }

    // }, 20);

    return ;
  }
}


function blurAll(){
  inputArr0.value.blur();
  inputArr1.value.blur();
  inputArr2.value.blur();
  inputArr3.value.blur();
  inputArr4.value.blur();
  inputArr5.value.blur();
}

function clear(){
  inputArr0.value='';
  inputArr1.value='';
  inputArr2.value='';
  inputArr3.value='';
  inputArr4.value='';
  inputArr5.value='';

  for (let i = 0; i < 6; i++) {
    vc_values.value[i]='';
  }
}

</script>
<script>
export default {
  name: 'NInviteVerifyCode',
};
</script>
<style lang="less">

.n-invite-reg-code-box {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  
  .ant-input-number {
    border-width: 0.08em !important;
  }
  .ant-input-number:hover {
    border-color: inherit;
  }
  .ant-input-number-focused {
    border-color: #409eff !important;
    box-shadow: none;
  }
  .ant-input-number-active {
    border-color: #409eff !important;
    box-shadow: none;
  }
  
  .n-invite-reg-code-input {
    .ant-input-number-input-wrap {
      margin: 6px 1px;

    }
  }
  
}

.n-invite-reg-code-input {
  width: 40px;
  height: 50px;
  font-size: 24px;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;
  input {
    text-align: center;
  }
}


</style>
